import { Activity } from 'app/activity/models/activity.model';

export class DaypartsActivity extends Activity {

  constructor(activity?: Activity) {
    super(activity);
  }

}
